export default __webpack_public_path__ + "static/media/box.9d37b511.png";